import { gql } from '@apollo/client';
import type { PagedResult } from './taskManagementQueries';

export type TmsTaskRelatedFilter = {
  orderId?: number;
  trackingNumber?: string;
  bagId?: number;
  bagNumber?: string;
};

export type TmsTaskRelatedLoadingItem = {
  loadingDetailId: number;
  taskId: number | null;
  waypointId: number | null;
  /** 装车时间：tms_loading_detail.created_at（UTC） */
  createdAt: string | null;
  bagId: number | null;
  bagNumber: string | null;
  /** 任务行不存在（已删除的任务不算缺失，见 taskDeleted） */
  taskMissing: boolean;
  /** 任务已逻辑删除（基础信息仍返回） */
  taskDeleted: boolean;
  taskNumber: string | null;
  taskStatus: number | null;
  taskType: number | null;
  businessType: number | null;
  taskDate: string | null;
  routeId: number | null;
  routeName: string | null;
};

export type TmsTaskRelatedLoadingsResponse = {
  opsToolTmsTaskRelatedLoadings: PagedResult<TmsTaskRelatedLoadingItem>;
};

export const TMS_TASK_RELATED_LOADINGS = gql`
  query OpsToolTmsTaskRelatedLoadings($filter: OpsTmsTaskRelatedFilterInput!, $pageRequest: PageRequestTypeInput) {
    opsToolTmsTaskRelatedLoadings(filter: $filter, pageRequest: $pageRequest) {
      content {
        loadingDetailId
        taskId
        waypointId
        createdAt
        bagId
        bagNumber
        taskMissing
        taskDeleted
        taskNumber
        taskStatus
        taskType
        businessType
        taskDate
        routeId
        routeName
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;
